import { Media } from './media';
export interface Color {
  r: number;
  g: number;
  b: number;
  a: number;
}

export interface PaginatedRecords<T> {
  currentPage: number,
  totalPages: number,
  totalRecordsCount: number,
  recordsPerPage: number,
  records: T[],
  nextPage?: number
}


export interface Banner {
  position: string,
  sharedByEnabled: boolean,
  background?: Media,
  autoHeightEnabled: boolean,
  bannerHeight: number | null,
  filter: string | null,
  overlayColor: Color | null,
  fontColor: Color | null,
  descriptionOverlay: string | null
  crop?: {
    x: number,
    y: number,
    width: number,
    height: number
  } | null;
  mediaType?: "image" | "video"; 
}
export enum ContentType {
  Asset = "asset",
  Collection = "collection"
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC"
}

export interface Author {
  email: string;
  firstName: string;
  admin: boolean;
  consent?: any;
  createdDate?: number | null;
  emailSignature?: string | null;
  icon?: Media;
  id?: string;
  lastActivityDate?: Date;
  lastName?: string;
  mobilePhone?: string;
  modifiedDate?: Date;
  overrideSSOConfiguration?: boolean;
  permissions?: any;
  title?: string;
  userGroups?: any;
  userRoleId?: string | null;
  userRoleName?: string | null;
  userRoles?: any;
  workPhone?: string;
}
export interface AssetSettings {
  download: boolean;
  seek: boolean;
  share: boolean;
  socialShare: boolean;
}

export interface Metadata {
  content_type: string;
  modified_date: number;
  url: string;
  md5_checksum: string | null;
  original_name: string;
  content_length: number;
  extension: string | null;
  etag: string;
  gsuite_alternate_link?: string;
  video_duration?: number;
  gsuite_web_view_url?: string;
}

export interface ThumbnailType {
  id: string;
  type: 'image' | 'video';
  key?: string;
  thumbnail?: string;
  full?: string;
  crop?: {
    x: number,
    y: number,
    width: number,
    height: number
  }
}
export interface Pagination{
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNext: boolean;
}
